import { i18n } from '../i18n';

const NUMBER_LOCALES: Record<string, string> = {
  de: 'de-DE',
  en: 'en-US',
  sl: 'sl-SI',
  ro: 'ro-RO',
  tr: 'tr-TR',
};

/** Locale for numbers, amounts and month names in the UI language (falls back to de-DE). */
export function numberLocale(lang: string = i18n.language): string {
  return NUMBER_LOCALES[lang] ?? NUMBER_LOCALES.de;
}

/** Placeholder for a missing number, e.g. an amount or rate that is not set. */
export const MISSING_NUMBER = '\u2014';

/**
 * Makes every space non-breaking. why: a formatted number and its unit ("€", "%") must never
 * wrap onto two lines in narrow table columns.
 */
export function keepTogether(formatted: string): string {
  return formatted.replace(/ /g, '\u00A0');
}
